import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Container } from '@mui/material';
import { presentationData } from './presentationData';
import Title from '../title/Title'

export default function Presentations() {
  const handleClick = (url) => {
    window.open(url, '_blank');
  };

  return (
    <Container maxWidth="xl">
      <Title title="Sunumlar" />
      <Box sx={{ 
        flexGrow: 1, 
        p: { xs: 1, sm: 2, md: 3 },
        minHeight: 'auto'
      }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="presentations table">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Sunum Adı</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {presentationData.map((presentation) => (
                <TableRow
                  key={presentation.id}
                  hover
                  onClick={() => handleClick(presentation.URL)}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell>{presentation.id}</TableCell>
                  <TableCell>{presentation.name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Container>
  );
}
